import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./navbar.css";
import BJT_Logo from "../../assets/Images/blackjadetattoo-logo2.png";

export default function Navbar() {
  //  the useEffect hook to listen for scroll events and update the state to reflect whether the .nav element should have the "affix" class.
  const [isAffix, setIsAffix] = useState(false);

  // Sticky Navbar ---------
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsAffix(true);
        console.log("OK");
      } else {
        setIsAffix(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Mobile menu ---------------
  const [isNavActive, setIsNavActive] = useState(false);

  // Reference the div to remove the "show_mobile_list" class
  const navRef = useRef(null);

  const handleNavClick = () => {
    // Remove the "show_mobile_list" class after a link is clicked
    navRef.current.classList.remove("show_mobile_list");
    // Mobile menu toggle to true/false
    setIsNavActive(!isNavActive);
    console.log("expand menu");
  };

  // Scroll to top on navigation with smooth animation -----------
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <nav className={`nav ${isAffix ? "affix" : null}`}>
      <div className="container-fluid">
        <div className="logo">
          <a href="/">
            <img src={BJT_Logo} alt="" className="bjt-logo" />
          </a>
        </div>
        <div
          ref={navRef}
          id="mainListDiv"
          className={` main_list mobile_list ${
            isNavActive ? "show_mobile_list" : ""
          }`}
        >
          <ul className="navlinks">
            <li>
              <NavLink to="/" className="nav-button" onClick={handleNavClick}>
                HOME
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className="nav-button"
                onClick={handleNavClick}
              >
                ABOUT
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/service"
                className="nav-button"
                onClick={handleNavClick}
              >
                SERVICE
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/artists"
                className="nav-button"
                onClick={handleNavClick}
              >
                ARTISTS
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/blog"
                className="nav-button"
                onClick={handleNavClick}
              >
                BLOG
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className="nav-button"
                onClick={handleNavClick}
              >
                CONTACT
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/booking"
                className="nav-button"
                onClick={handleNavClick}
              >
                BOOKING
              </NavLink>
            </li>
            <li>
              <a
                href="https://www.instagram.com/blackjadetattoo/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-instagram social-icon"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/blackjadetattoo/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-facebook social-icon"></i>
              </a>
            </li>
          </ul>
        </div>
        <span
          className={`navTrigger ${isNavActive ? "active" : ""}`}
          onClick={handleNavClick}
        >
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
    </nav>
  );
}
